module.exports = __webpack_public_path__ + "img/ru.77432482.svg";